import React, {useEffect, useContext, useMemo, useState} from 'react';

import { Form, Select, Tooltip, App } from "antd";
import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import { Settings } from './settings';
import { Resizer,FormContext } from 'wsc-react-custom-form';
import { request } from '@/utils/useRequest';
import DictDetail from "./dict-detail";
import { useEditorStore } from "@/store/useEditorStore";
import useNameOfForm from "@/hooks/useNameOfForm";

const defaultProps = {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    fillSpace: 'no',
    padding: ['0', '0', '0', '0'],
    margin: ['0', '0', '0', '0'],
    background: { r: 255, g: 255, b: 255, a: 1 },
    color: { r: 0, g: 0, b: 0, a: 1 },
    shadow: 0,
    radius: 0,
    width: '100%',
    height: 'auto',
};

export const FlowDict = (props) => {
    const { modal, message } = App.useApp();
    props = {
        ...defaultProps,
        ...props,
    };
    const {
        flexDirection,
        alignItems,
        justifyContent,
        fillSpace,
        background,
        color,
        padding,
        margin,
        shadow,
        radius,
        label,
        labelSpan,
        labelOffset,
        wrapperSpan,
        wrapperOffset,
        showLabel,
        name,
        rules,
        for_type,
        id,
    } = props;

    const node_map = useEditorStore.use.node_map();
    const nodes = useEditorStore.use.nodes();
    const activeFlow = useEditorStore.use.activeFlow();
    const removeNode = useEditorStore.use.removeNode();
    const { form, formdata, nameArray, value: initValue } = useNameOfForm(name);

    // const [options, setOptions] = useState([]);
    const formInstance = Form.useFormInstance();
    const value = Form.useWatch(nameArray, formInstance);
    const [displayDictDetail, setDisplayDictDetail] = React.useState(false);
    const [idFlag, setIdFlag] = React.useState(undefined);
    const [optionsInFlowMap, setOptionsInFlowMap] = React.useState([]);
    const [optionsGlobal, setOptionsGlobal] = React.useState([]);

    useEffect(()=> {
        const result = [];
        Object.entries(node_map).forEach(([, value]) => {
            if (value?.type === for_type) {
                result.push(value);
            }
            // console.log('type instance in flow map: ', for_type, result);
        });
        setOptionsInFlowMap(result.map(item => ({label: item.name, value: item.id})));
    }, [node_map, for_type]);
    useEffect(() => {
        if (!formdata.id || !for_type) return;
        const url = `/api/v5/private/dict/list/${formdata.id}/${for_type}`;
        request(url, "GET").then((res) => {
            if (res.success) {
                setOptionsGlobal(
                    res.data
                        .filter(item => item.flow_id !== activeFlow)
                        .map(item => ({label: `${item.name}(${item.flow_id})`, value: item.id})));
                // setOptions(res.data.map(item => ({label: item.name, value: item.id})));
            }
        })
    }, [for_type, formdata.id]);

    // console.log('formdata', formdata, props);
    // 合并本地的和全局的options
    const mergedOptions = [
        ...optionsInFlowMap,
        ...optionsGlobal.filter(item => !optionsInFlowMap.some(op => op.value === item.value)),
    ];

    let noLabel = (showLabel == "false");
    return (<Resizer
        propKey={{width: 'width', height: 'height'}}
        style={{
            justifyContent,
            flexDirection,
            alignItems,
            background: `rgba(${background.r},${background.g},${background.b},${background.a})`,
            color: `rgba(${color.r},${color.g},${color.b},${color.a})`,
            padding: `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`,
            margin: `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`,
            boxShadow:
                shadow === 0
                    ? 'none'
                    : `0px 3px 100px ${shadow}px rgba(0, 0, 0, 0.13)`,
            borderRadius: `${radius}px`,
            flex: fillSpace === 'yes' ? 1 : 'unset',
            position: 'relative',
        }}
    ><Form.Item
        style={{width: "100%"}}
        label={noLabel ? null : label}
        labelCol={{span: labelSpan, offset: labelOffset}}
        wrapperCol={{span: wrapperSpan, offset: wrapperOffset}}
        name={nameArray}
        rules={rules}
    >
        <Select
            options={mergedOptions}
            style={{width: '100%'}}
        >
        </Select>

    </Form.Item>

    <div className='flex flex-row items-start pt-0 gap-x-1 absolute right-2 h-full'>
        <Tooltip title='新增'>
            <div className='px-2 py-1 border border-solid border-gray-300 cursor-pointer'
                 onClick={()=> {
                     setIdFlag(undefined);
                     setDisplayDictDetail(true);
                 }}
            >
                <PlusOutlined />
            </div>
        </Tooltip>

        {/* 其他flow文件的全局配置不能编辑 */}
        { value && optionsInFlowMap.some(item => item.value === value) &&
            <>
                <Tooltip title='编辑'>
                    <div className='px-2 py-1 border border-solid border-gray-300 cursor-pointer'
                         onClick={()=> {
                             if (!value) return;
                             setIdFlag(value);
                             setDisplayDictDetail(true);
                         }}
                    >
                        <EditOutlined/>
                    </div>
                </Tooltip>

                <Tooltip title='删除'>
                    <div className='px-2 py-1 border border-solid border-gray-300 cursor-pointer'
                         onClick={async ()=> {
                             if (!value) return;
                             // todo 使用中的不能删除（但这里只是判断在本flow中使用）
                             const usedInCurrentFlow = Object.entries(node_map).some(([_, val])=> {
                                 if (!val.props) return false;
                                 return Object.entries(val.props).some(([_, prop])=> prop === value)
                             });
                             const usedInGlobal = nodes.some(node => {
                                 if (!node.props) return false;
                                 return Object.entries(node.props).some(([_, prop])=> prop === value)
                             });
                             // console.log('usedInCurrentFlow', usedInCurrentFlow, usedInGlobal);
                             if (usedInCurrentFlow) {
                                 message.warning({content: '该节点已经在当前flow被使用，不能删除'});
                                 return;
                             } else if (usedInGlobal) {
                                 message.warning({content: '该节点已经在其他flow被使用，不能删除'});
                                 return;
                             }
                             else {
                                 const confirmed = await modal.confirm({
                                     title: '确认',
                                     content: '该节点未在本flow中使用（但可能在其他节点中使用），确认要删除吗？',
                                 });
                                 if (!confirmed) return;
                             }
                             removeNode(value);
                             form.setFieldValue(nameArray, undefined);
                         }}
                    >
                        <DeleteOutlined/>
                    </div>
                </Tooltip>
            </>
        }

    </div>

        {displayDictDetail && (
            <DictDetail
                display={displayDictDetail}
                onClose={()=>setDisplayDictDetail(false)}
                forType={for_type}
                idFlag={idFlag}
            />
        )}

    </Resizer>);
};

FlowDict.displayName = 'FlowDict';
FlowDict.craft = {
    displayName: 'FlowDict',
    props: {
        name: "server",
        label: "服务器",
        labelSpan: 6,
        labelOffset: 0,
        wrapperSpan: 18,
        wrapperOffset: 0,
        showLabel: "true",
        multiple: "false",
        disabled: "false",
        rules: [{ required: true, message: "必须填写！" }],
        for_type: "mqtt-broker",
        ...defaultProps
    },
    related: {
        toolbar: Settings,
    },
};

FlowDict.Icon = () => {
    return (<span>FlowDict</span>);
}